"use client";

import React, { FC } from "react";
import Typography from "../typography";

interface Props {
  id: string;
  isChecked: boolean;
  onChange: () => void;
  text?: string;
  large?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  largeTextOnly?: boolean;
}

/**
 * Component for a generic checkbox with optional text.
 * @param interface
 * @returns a checkbox.
 */
const Checkbox: FC<Props> = ({
  id,
  isChecked,
  onChange,
  text = "",
  large = false,
  children,
  disabled = false,
  largeTextOnly = false,
}) => {
  const variant = large || largeTextOnly ? "Body" : "Description";

  return (
    <div className="flex items-start space-x-2">
      <div>
        <input
          disabled={disabled}
          onChange={() => onChange()}
          checked={isChecked}
          id={id}
          type="checkbox"
          value=""
          className={`${
            large ? "w-5 h-5" : "w-4 h-4"
          } accent-blueDark bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark border-gray-300 rounded focus:ring-blue-500 focus:ring-2 mt-1`}
        />
      </div>
      <label htmlFor={id} className={`${disabled ? "text-greyShadow" : ""}`}>
        {text ? <Typography variant={variant}>{text}</Typography> : children}
      </label>
    </div>
  );
};

export default Checkbox;
